"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ar_1 = require("./ar");

var api_1 = require("./lib/api");

var network_1 = require("./network");

var transactions_1 = require("./transactions");

var wallets_1 = require("./wallets");

var transaction_1 = require("./lib/transaction");

var ArweaveUtils = require("./lib/utils");

var silo_1 = require("./silo");

var Arweave =
/*#__PURE__*/
function () {
  function Arweave(config) {
    _classCallCheck(this, Arweave);

    this.crypto = config.crypto;
    this.api = new api_1.default(config.api);
    this.wallets = new wallets_1.default(this.api, config.crypto);
    this.transactions = new transactions_1.default(this.api, config.crypto);
    this.silo = new silo_1.default(this.api, this.crypto, this.transactions);
    this.network = new network_1.default(this.api);
    this.ar = new ar_1.default();
    this.utils = ArweaveUtils;
  }

  _createClass(Arweave, [{
    key: "getConfig",
    value: function getConfig() {
      return {
        api: this.api.getConfig(),
        crypto: null
      };
    }
  }, {
    key: "createTransaction",
    value: function () {
      var _createTransaction = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(attributes, jwk) {
        var from, transaction, length;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.wallets.jwkToAddress(jwk);

              case 2:
                from = _context.sent;
                transaction = {};
                Object.assign(transaction, attributes);

                if (!(!attributes.data && !(attributes.target && attributes.quantity))) {
                  _context.next = 7;
                  break;
                }

                throw new Error("A new Arweave transaction must have a 'data' value, or 'target' and 'quantity' values.");

              case 7:
                if (attributes.owner == undefined) {
                  transaction.owner = jwk.n;
                }

                if (!(attributes.last_tx == undefined)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return this.transactions.getTransactionAnchor();

              case 11:
                transaction.last_tx = _context.sent;

              case 12:
                if (typeof attributes.data === "string") {
                  attributes.data = ArweaveUtils.stringToBuffer(attributes.data);
                }

                if (!(attributes.data && !(attributes.data instanceof Uint8Array))) {
                  _context.next = 15;
                  break;
                }

                throw new Error("Expected data to be a string or Uint8Array");

              case 15:
                if (!(attributes.reward == undefined)) {
                  _context.next = 20;
                  break;
                }

                length = attributes.data ? attributes.data.byteLength : 0;
                _context.next = 19;
                return this.transactions.getPrice(length, transaction.target);

              case 19:
                transaction.reward = _context.sent;

              case 20:
                if (attributes.data) {
                  transaction.data = ArweaveUtils.bufferTob64Url(attributes.data);
                }

                return _context.abrupt("return", new transaction_1.default(transaction));

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createTransaction(_x, _x2) {
        return _createTransaction.apply(this, arguments);
      }

      return createTransaction;
    }()
  }, {
    key: "createSiloTransaction",
    value: function () {
      var _createSiloTransaction = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(attributes, jwk, siloUri) {
        var from, transaction, siloResource, encrypted, _encrypted, siloTransaction;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.wallets.jwkToAddress(jwk);

              case 2:
                from = _context2.sent;
                transaction = {};
                Object.assign(transaction, attributes);

                if (attributes.data) {
                  _context2.next = 7;
                  break;
                }

                throw new Error("Silo transactions must have a 'data' value");

              case 7:
                if (siloUri) {
                  _context2.next = 9;
                  break;
                }

                throw new Error("No Silo URI specified.");

              case 9:
                if (!(attributes.target || attributes.quantity)) {
                  _context2.next = 11;
                  break;
                }

                throw new Error("Silo transactions can only be used for storing data, sending AR to other wallets isn't supported.");

              case 11:
                if (attributes.owner == undefined) {
                  transaction.owner = jwk.n;
                }

                if (!(attributes.last_tx == undefined)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 15;
                return this.transactions.getTransactionAnchor();

              case 15:
                transaction.last_tx = _context2.sent;

              case 16:
                _context2.next = 18;
                return this.silo.parseUri(siloUri);

              case 18:
                siloResource = _context2.sent;

                if (!(typeof attributes.data == "string")) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return this.crypto.encrypt(ArweaveUtils.stringToBuffer(attributes.data), siloResource.getEncryptionKey());

              case 22:
                encrypted = _context2.sent;
                _context2.next = 25;
                return this.transactions.getPrice(encrypted.byteLength);

              case 25:
                transaction.reward = _context2.sent;
                transaction.data = ArweaveUtils.bufferTob64Url(encrypted);

              case 27:
                if (!(attributes.data instanceof Uint8Array)) {
                  _context2.next = 35;
                  break;
                }

                _context2.next = 30;
                return this.crypto.encrypt(attributes.data, siloResource.getEncryptionKey());

              case 30:
                _encrypted = _context2.sent;
                _context2.next = 33;
                return this.transactions.getPrice(_encrypted.byteLength);

              case 33:
                transaction.reward = _context2.sent;
                transaction.data = ArweaveUtils.bufferTob64Url(_encrypted);

              case 35:
                siloTransaction = new transaction_1.default(transaction);
                siloTransaction.addTag("Silo-Name", siloResource.getAccessKey());
                siloTransaction.addTag("Silo-Version", "0.1.0");
                return _context2.abrupt("return", siloTransaction);

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createSiloTransaction(_x3, _x4, _x5) {
        return _createSiloTransaction.apply(this, arguments);
      }

      return createSiloTransaction;
    }()
  }, {
    key: "arql",
    value: function arql(query) {
      return this.api.post("/arql", query).then(function (response) {
        return response.data || [];
      });
    }
  }]);

  return Arweave;
}();

exports.default = Arweave;